import { createSlice } from '@reduxjs/toolkit'

interface InitState {
  applicationMode: string
  channelId: string
  marketCode: 'SE-SKBV' | 'SE-BYME' | 'NO-GF' | 'FI-NR' | 'NO-BYME' | ''
  languageCode: 'sv_SE' | 'nb_NO' | 'sv_FI' | 'fi_FI' | ''
  langMarketCode: 'sv-SE-SKBV' | 'sv-SE-BYME' | 'nb-NO-GF' | 'sv-FI-NR' | 'fi-FI-NR' | 'nb-NO-BYME' | '' | any
  assetBaseUrl: string
  content: Record<PropertyKey, any>
}

const initialState: InitState = {
  applicationMode: '',
  channelId: '',
  marketCode: '',
  languageCode: '',
  langMarketCode: '',
  assetBaseUrl: '',
  content: {},
}

const initSlice = createSlice({
  name: 'init',
  initialState,
  reducers: {
    handleAppInit(state, action) {
      const { applicationMode, channelId, marketCode, languageCode, assetBaseUrl, content } = action.payload

      state.applicationMode = applicationMode
      state.channelId = channelId
      state.marketCode = marketCode
      state.languageCode = languageCode
      state.langMarketCode = `${languageCode.substring(0, 2)}-${marketCode}`
      state.assetBaseUrl = assetBaseUrl
      state.content = content
    },
  },
})

export const { handleAppInit } = initSlice.actions

export default initSlice.reducer
